import React from 'react'
import { storiesOf } from '@storybook/react'
import { Player, Jersey } from 'protos'
import Team from 'components/Team'

const players = [
  Player.create({
    playerId: 'playerA',
    name: 'Player A',
    jersey: Jersey.create({
      baseColor: '000000',
      sleeveColor: 'cccccc',
      numberColor: 'ffffff'
    })
  }),
  Player.create({
    playerId: '123',
    name: 'Player B',
    jersey: Jersey.create({
      baseColor: 'cccccc',
      sleeveColor: 'cccccc',
      numberColor: 'ffffff'
    })
  }),
  Player.create({
    name: 'Player C',
    jersey: Jersey.create({
      baseColor: 'cccccc',
      sleeveColor: 'f0f1f2',
      numberColor: 'ffffff'
    })
  }),
  Player.create({
    name: 'Player D',
    jersey: Jersey.create({
      baseColor: 'f0f0f1',
      sleeveColor: 'cccccc',
      numberColor: 'ffffff'
    })
  }),
]

storiesOf('Team', module)
  .add('default', () => (
    <Team
      players={players}
    />
  ))
  .add('with remove icon', () => (
    <Team
      showRemoveIcon
      players={players}
    />
  ))
